import React, {useEffect, useMemo, useState, useRef} from 'react';
import {connect} from 'react-redux';
import ValidationInputsWithRadio from '../../Shared/ValidationInputsWithRadio/ValidationInputsWithRadio';
import {
  setCustomerNumber,
  setFormType,
  GetCustomerDetailsForBusinessContactManager,
  setIsShowPopup,
  ChangeClientName,
  reportDWH,
} from '../PortalsBlock/portalSlice';
import {showAppLoader, hideAppLoader} from '../../Shared/Loader/LoaderSlice';
import ChangeHetPayPopUp from './ChangeHetPayPopUp';
import ClientInformationSuccess from './ClientInformationSuccess';
import PopUp from '../../Shared/Popup/PopUp';
import {Col, Row, Button, Container, Input} from 'reactstrap';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import BtnWhite from '../../Shared/Buttons/BtnWhite';
import {isMobile} from 'react-device-detect';
import EpiContext from '@episerver/spa-core/Spa';
import Config from '../../../Config';
import {reportDWHBuilder} from './reportDWH';
import {gtag4} from '../../../utilities/analytics/tracking';
import {ImeiChangeSuccsess} from './ImeiChangeSuccsess';

const ClientInformationMain = (props) => {
  useEffect(() => {
    if (!oldHetPay.id) {
      getOldHetPayName();
    }
    reportDWH('SHOWPAGE', {param1: props.portalState.selectedHetPay});
    gtag4({
      event: 'UpdateSubscriberInfo_FormImp',
      action: 'FormImp',
    });
  }, []);

  useEffect(() => {}, [props.portalState.isShowPopup, props.portalState.isImeiChangeSuccsess]);

  const reportDWH = (mode, params) => {
    const report = reportDWHBuilder(mode, params, props);
    props.reportDWH(report);
  };

  const data = props.iContent;
  const form = [
    {
      inputName: 'מספר טלפון',
      id: 1,
      formType: 'PHONE',
      pattern: '[0-9]*',
      maxLength: '10',
      regexPattern: '^[0-9]{10}$',
    },
    {
      inputName: 'מספר סים',
      id: 2,
      formType: 'SIM',
      pattern: '[0-9]*',
      maxLength: '18',
      regexPattern: '^[0-9]{18}$',
    },
  ];

  const [typedNumber, setTypedNumber] = useState({
    id: null,
    value: '',
  });

  const [formType, setFormType] = useState({
    id: '',
    formType: '',
  });

  const [isAllowed, setIsAllowed] = useState({
    description: 'initialState',
    isAllowed: false,
  });

  const [oldHetPay, setOldHetPay] = useState({
    id: '',
    name: '',
  });

  const onPopupClosing = async () => {
    await props.setIsShowPopup(false);

    setIsAllowed({
      description: 'initialState',
    });
    return props.portalState.isShowPopup;
  };

  const getOldHetPayName = () => {
    props.portalState?.hetPaysNumbers?.map((h) => {
      if (h.id === props.portalState.selectedHetPay)
        setOldHetPay({
          id: h.id,
          name: h.name,
        });
    });
  };

  async function getCustomerNumber(customerNumber, formType) {
    reportDWH('BUTTON_CLICK', {param10: customerNumber, param2: formType, param1: props.portalState.selectedHetPay});
    gtag4({
      event: 'UpdateSubscriberInfo_ContinueButton',
      button: 'המשך',
      content: formType === 'PHONE' ? 'הזן מספר טלפון' : 'הזן מספר סים',
      action: 'ContinueButton',
    });
    props.showAppLoader();
    let orgId;
    setIsAllowed({description: 'isLoading'});
    props.setCustomerNumber(customerNumber);
    props.setFormType(formType);
    props.portalState?.privateCompanyList.map((company) => {
      if (company.idNumber === props.portalState?.selectedHetPay) {
        return (orgId = company.orgId);
      }
    });
    const result = await props.GetCustomerDetailsForBusinessContactManager({
      orgId: orgId,
      customerNumber: customerNumber,
      formType: formType,
    });
    setIsAllowed(result.payload);
    if (result.payload.description === 'MemberOfDifferentOrg' || result.payload.description === 'OrgIdNotFound') {
      props.setIsShowPopup(true);
      reportDWH('SUB_DIFF_ORG', {param10: customerNumber, param2: formType, param1: props.portalState.selectedHetPay});
      gtag4({
        event: 'UpdateSubscriberInfo_PersonalAreaButton',
        content: result.payload.newOrgName ?? '',
        button: 'המשך בתהליך',
        action: 'PersonalAreaButton',
      });
    }
    if (result.payload.description === 'PhoneNumberNotFound') {
      reportDWH('SUB_NOT_FOUND', {param10: customerNumber, param2: formType, param1: props.portalState.selectedHetPay});
    }
    if (result.payload.error) {
      reportDWH('GEN_ERR', {param10: customerNumber, param2: formType, param1: props.portalState.selectedHetPay});
    }
    if (result.payload.isAllowed || result.payload.description === 'MemberOfDifferentOrg') {
    }
    props.hideAppLoader();
  }
  const getCustomerValidationErrorDescription = () => {
    let error;
    if (isAllowed.description == 'PhoneNumberNotFound') {
      error = `לא נמצא מנוי, אנא נסה שוב`;
      gtag4({
        event: 'UpdateSubscriberInfo_ErrorMessage',
        error: 'לא נמצא מנוי, אנא נסה שוב',
        action: 'ErrorMessage',
      });
    } else if (isAllowed.description == 'AccountNotFound') {
      error = `מנוי זה לא משוייך לאחד מהארגונים שלך, אנא נסה שוב`;
    } else if (isAllowed.description == 'MemberOfDifferentOrg') {
      error = `מנוי זה משוייך לארגון אחר, אנא נסה שוב`;
    } else if (isAllowed.description == 'ErrorOnValidation' || isAllowed.description == 'Unknown' || isAllowed.error) {
      error = `קרתה תקלה במהלך הזיהוי, אנא נסה שוב`;
      gtag4({
        event: 'UpdateSubscriberInfo_ErrorMessage',
        error: 'קרתה תקלה במהלך הזיהוי, אנא נסה שוב',
        action: 'ErrorMessage',
      });
    }
    return error;
  };

  const getButtonModes = () => {
    if (isAllowed.description === 'initialState') {
      return (
        <Row className='justify-content-center mt-5'>
          <Col xs='12' className={`btn-220 btn-row pr-0 pl-0 text-center ${!pattern.test(typedNumber.value) && 'disabled-btn'}`}>
            <BtnSubmit isBusiness text={`המשך`} onclick={() => getCustomerNumber(typedNumber.value, formType.formType)} />
          </Col>
        </Row>
      );
    } else if ((isAllowed.isAllowed == false || isAllowed.error) && isAllowed.description !== 'MemberOfDifferentOrg') {
      return (
        <>
          <Row className='account-denied text-center  mt-2'>
            <Col xs='12' className='justify-content-center pr-0 pl-0'>
              <p className='font-14 newPurple-text mb-1'>{getCustomerValidationErrorDescription()}</p>
            </Col>
            <Col xs='12' className='justify-content-center pr-0 pl-0'>
              {isMobile ? (
                <a href={`tel:${window.Config.businessCallNumber}`} className='font-14 bold asBtn'>
                  אחרת חייג 234* לשיחה עם צוותון שירות
                </a>
              ) : (
                <p className='font-14 bold mb-0'>חיוג 234* לשיחה עם צוותון שירות</p>
              )}
            </Col>
          </Row>
          <Row className='justify-content-center mt-3'>
            <Col xs='12' className={`btn-220 btn-row pr-0 pl-0 text-center ${!pattern.test(typedNumber.value) ? 'disabled-btn' : ''}`}>
              <BtnSubmit isBusiness text={`נסה שוב`} onclick={() => getCustomerNumber(typedNumber.value, formType.formType)} />
            </Col>
          </Row>
          <Row className='justify-content-center mt-2'>
            <Col xs='12' className={`btn-220 btn-row pr-0 pl-0 text-center }`}>
              <BtnWhite isBusiness text={`חזרה לאיזור האישי`} onclick={() => EpiContext.navigateTo(Config.businessLobbyUrl)} />
            </Col>
          </Row>
        </>
      );
    }
  };
  let pattern = new RegExp('^.*[a-zA-Z0-9]+.*$');
  const patternTest = () => {
    form.map((f) => {
      if (f.id === typedNumber.id) {
        if (f.regexPattern) {
          pattern = new RegExp(f.regexPattern);
        } else {
          pattern = new RegExp('^.*[a-zA-Z0-9]+.*$');
        }
      }
    });
  };
  patternTest();
  const radioButtonClick = (id, formType) => {
    setFormType({
      id: id,
      formType: formType,
    });
    if (typedNumber.value) {
      setTypedNumber((state) => {
        return {
          id: null,
          value: '',
        };
      });
    }
  };
  const onButtonClick = () => {
    props.setIsShowPopup(false);
    props.hideAppLoader();
    setIsAllowed({
      ...isAllowed,
      isAllowed: true,
    });
  };
  const onSaveNewName = async (newName) => {
    props.showAppLoader();
    const res = await props.ChangeClientName({
      orgId: isAllowed.orgId ? isAllowed.orgId : isAllowed.newOrgIdNumber,
      selectedNumber: isAllowed.phoneNumber,
      newFirstName: newName.firstName,
      newLastName: newName.lastName,
    });

    if (res.payload.isSuccess) {
      setIsAllowed({...isAllowed, subscriberName: res.payload.newClientName});
    }
    props.hideAppLoader();
    return res;
  };
  return (
    <>
      <div className='client-information-main'>
        {!isAllowed.isAllowed && (
          <ValidationInputsWithRadio
            onButtonClick={getCustomerNumber}
            title={data?.title?.value}
            boldTitle={data?.boldTitle?.value}
            data={isAllowed}
            form={form}
            typedNumber={typedNumber}
            setTypedNumber={setTypedNumber}
            formType={formType}
            setFormType={setFormType}
            getButtonModes={getButtonModes}
            radioButtonClick={radioButtonClick}
          />
        )}
        <PopUp showPopUp={props.portalState.isShowPopup} onClose={() => onPopupClosing()}>
          <ChangeHetPayPopUp
            isAllowed={isAllowed}
            setIsAllowed={setIsAllowed}
            oldHetPay={oldHetPay}
            setIsShowPopup={props.setIsShowPopup}
            btnText={'קבלת פרטי מנוי'}
            onButtonClick={onButtonClick}
          />
        </PopUp>
        {isAllowed.isAllowed && (
          <>
            <div className='client-information-success'>
              <ClientInformationSuccess
                isAllowed={isAllowed}
                form={formType}
                oldHetPay={oldHetPay}
                customerPhoneNumber={props.portalState.customerPhoneNumber}
                onPopupClosing={onPopupClosing}
                onSaveNewName={onSaveNewName}
                isIMEIEditMode={props.portalState.isIMEIEditMode}
                isShowPopup={props.portalState.isShowPopup}
                setIsShowPopup={props.setIsShowPopup}
                reportDWH={reportDWH}
                selectedHetPay={props.portalState.selectedHetPay}
              />
            </div>
          </>
        )}
      </div>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    portalState: state.portalsBlock,
  };
};

const mapDispatchToProps = {
  setCustomerNumber,
  setFormType,
  GetCustomerDetailsForBusinessContactManager,
  ChangeClientName,
  showAppLoader,
  hideAppLoader,
  setIsShowPopup,
  reportDWH,
};

export default connect(mapStateToProps, mapDispatchToProps)(ClientInformationMain);
